import React, {useCallback, useEffect, useState} from 'react'
import {
  FaExclamationCircle,
  FaFileAlt,
  FaCheckCircle,
  FaPaperclip,
  FaCommentDots,
  FaCloudUploadAlt,
  FaTimes,
  FaTrash,
  FaExclamationTriangle,
} from 'react-icons/fa'
import axios from 'axios'
import './../style.css'
import ChatModal from './ChatModal'
import {toast} from 'react-toastify'
import {useAuth} from '../../../modules/auth'
import {ToastContainer} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Pusher from 'pusher-js'
import {Modal} from 'react-bootstrap'

interface DocumentsProps {
  claimDetails: any
  onDocumentClick: (docLabel: string) => void
  onDocumentsStatusChange: (status: boolean) => void
  onDocumentValidationChange?: (hasInvalid: boolean) => void
  onDocumentRealtimeUpdate?: (data: any) => void
  setIsReupload: (isReupload: boolean) => void
}

// Add interface for document type
interface ExpectedDocument {
  label: string
  key: number
}

const DocumentsFGL: React.FC<DocumentsProps> = ({
  claimDetails,
  onDocumentClick,
  onDocumentsStatusChange,
  onDocumentValidationChange,
  onDocumentRealtimeUpdate,
  setIsReupload,
}) => {
  const user = useAuth()
  const {auth} = useAuth()
  console.log('Token Documents: ', user.currentUser?.token)
  const [documentFiles, setDocumentFiles] = useState<Record<string, any[]>>({})
  const [uploadStatus, setUploadStatus] = useState<Record<string, boolean | null>>({})
  const [documentsData, setDocumentsData] = useState<any[]>([])
  const [isChatOpen, setIsChatOpen] = useState<boolean>(false)
  const [chatMessage, setChatMessage] = useState<string>('')
  const [activeOptionsModal, setActiveOptionsModal] = useState<{
    key: number
    label: string
    mode?: 'replace' | 'delete'
  } | null>(null)
  const [deletingFiles, setDeletingFiles] = useState<Record<string, boolean>>({})
  const [lastToastTime, setLastToastTime] = useState<number>(0)
  const [showOptionsModal, setShowOptionsModal] = useState(false)

  // Update expectedDocuments to include key property
  const expectedDocuments: ExpectedDocument[] = [
    {label: 'Resume Medis', key: 0},
    {label: 'Billing Akhir', key: 1},
    {label: 'Hasil Penunjang', key: 2},
  ]

  useEffect(() => {
    const initialFiles: Record<string, any[]> = {}
    expectedDocuments.forEach((doc) => {
      initialFiles[doc.label] = []
    })
    setDocumentFiles(initialFiles)
  }, [])

  const checkAllDocumentsUploaded = useCallback(() => {
    // Get all unique document labels from both default and API response
    const allDocumentLabels = new Set([
      ...expectedDocuments.map((doc) => doc.label),
      ...Object.keys(documentFiles),
    ])

    const allUploaded = Array.from(allDocumentLabels).every((label) => {
      // Skip Prescription documents
      if (label === 'Prescription') return true

      const files = documentFiles[label]
      return files && files.length > 0 && !files.some((file) => file.status === 'INVALID')
    })

    onDocumentsStatusChange(allUploaded)
  }, [documentFiles, onDocumentsStatusChange])

  useEffect(() => {
    checkAllDocumentsUploaded()
  }, [documentFiles, checkAllDocumentsUploaded])

  const fetchDocuments = async () => {
    const claimNumber = claimDetails.claimDetails.claimNumber
    const apiUrl = `${process.env.REACT_APP_API_CLAIM_URL}/api/Claims/ListFiles/${claimNumber}?area=Discharge`
    const headers = {
      Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
    }

    try {
      const response = await axios.get(apiUrl, {headers})
      if (response.data.isSuccess) {
        const apiDocuments = response.data.data

        // Check for invalid documents
        const hasInvalidDocuments = apiDocuments.some(
          (doc: any) =>
            doc.document &&
            doc.document.length > 0 &&
            doc.document.some((file: any) => file.status === 'INVALID' || file.status === 'Request Document')
        )

        // Create a map of all documents
        const allDocuments = new Map()

        // Add expected documents first with empty document arrays
        expectedDocuments.forEach((doc, index) => {
          allDocuments.set(doc.label, {
            label: doc.label,
            key: index,
            document: [],
          })
        })

        // Update with API documents
        apiDocuments.forEach((doc: any, index: number) => {
          if (!allDocuments.has(doc.label)) {
            // const existing = allDocuments.get(doc.label)
            allDocuments.set(doc.label, {
              label: doc.label,
              key: expectedDocuments.length + index,
              document: doc.document || [],
            })
          } else {
            const existing = allDocuments.get(doc.label)
            allDocuments.set(doc.label, {
              ...existing,
              document: doc.document,
            })
          }
        })
        console.log("all documents", apiDocuments);
        

        // Convert map back to array
        const finalDocuments = Array.from(allDocuments.values())

        // Create updated files object
        const updatedFiles: Record<string, any[]> = {}
        finalDocuments.forEach((doc: any) => {
          updatedFiles[doc.label] = (doc.document || []).map((file: any) => ({
            name: file.name,
            id: file.id,
            type: file.name.split('.').pop(),
            status: file.status,
            isArchive: file.isArchive,
          }))
        })

        // Use finalDocuments to ensure all expected labels are always present
        setDocumentsData(finalDocuments)
        setDocumentFiles(updatedFiles)

        // Update parent components
        const allDocumentsValid = !hasInvalidDocuments
        onDocumentsStatusChange(allDocumentsValid)
        if (onDocumentValidationChange) {
          onDocumentValidationChange(hasInvalidDocuments)
        }
      }
    } catch (error) {
      console.error('Error fetching documents:', error)
      toast.error('Failed to fetch documents. Please try again.', {
        position: 'bottom-right',
        autoClose: 3000,
      })
    }
  }

  useEffect(() => {
    fetchDocuments()
  }, [claimDetails])

  useEffect(() => {
    console.log('Token in useEffect:', user)
  }, [user])

  useEffect(() => {
    const pusher = new Pusher(`${process.env.REACT_APP_API_PUSHER_KEY!}`, {
      cluster: process.env.REACT_APP_API_PUSHER_CLUSTER! || 'ap1',
      forceTLS: true,
    })

    const claimNumber = claimDetails.claimDetails.claimNumber
    const fileStatusChannel = pusher.subscribe(`file-channel-${claimNumber}`)
    const listFileChannel = pusher.subscribe(`list-file-channel-${claimNumber}`)

    fileStatusChannel.bind(`get-${claimNumber}`, (data: any) => {
      if (data && data.message) {
        const {message} = data
        const {Label, Status, Id, DocumentName, isArchive, UpdatedBy} = message

        // Update document files state immediately
        setDocumentFiles((prevState) => ({
          ...prevState,
          [Label]: [
            {
              name: DocumentName,
              id: Id,
              type: DocumentName.split('.').pop(),
              status: Status,
              isArchive: isArchive,
            },
          ],
        }))

        // Update documents data state
        setDocumentsData((prevData) => {
          return prevData.map((doc) => {
            if (doc.label === Label) {
              return {
                ...doc,
                document: [
                  {
                    name: DocumentName,
                    id: Id,
                    status: Status,
                    isArchive: isArchive,
                  },
                ],
              }
            }
            return doc
          })
        })

        // Check for any invalid documents
        const hasInvalidDocuments = Object.values(documentFiles).some((files) =>
          files.some((file) => file.status === 'INVALID')
        )

        // Check if all required documents are uploaded
        const allDocumentsUploaded = expectedDocuments.every(
          (doc) => documentFiles[doc.label]?.length > 0
        )

        // Update parent components
        onDocumentsStatusChange(allDocumentsUploaded && !hasInvalidDocuments)
        if (onDocumentValidationChange) {
          onDocumentValidationChange(hasInvalidDocuments)
        }

        // Show toast for invalid documents
        const now = Date.now()
        if (Status === 'INVALID' && now - lastToastTime > 5000) {
          toast.error(`${Label} has been rejected by ${UpdatedBy}. Please review and resubmit.`, {
            position: 'top-right',
            autoClose: 3000,
          })
          setLastToastTime(now)
        }
      }
    })

    listFileChannel.bind(`get-list-${claimNumber}`, (data: any) => {
      console.log('Received list file data:', data)

      if (data.isSuccess) {
        // Pass the realtime data up to parent
        if (onDocumentRealtimeUpdate) {
          onDocumentRealtimeUpdate(data)
        }

        const apiDocuments = data.data

        // Check for invalid documents
        const hasInvalidDocuments = apiDocuments.some(
          (doc: any) =>
            doc.document &&
            doc.document.length > 0 &&
            doc.document.some((file: any) => file.status === 'INVALID')
        )

        // Check if all required documents are present
        const allDocumentsUploaded = expectedDocuments.every((defaultDoc) =>
          apiDocuments.some(
            (apiDoc) =>
              apiDoc.label === defaultDoc.label && apiDoc.document && apiDoc.document.length > 0
          )
        )

        // Create maps for easier comparison
        const defaultDocsMap = new Map(expectedDocuments.map((doc) => [doc.label, doc]))
        const apiDocsMap = new Map(apiDocuments.map((doc: any) => [doc.label, doc]))

        // Determine which set of documents to use based on our strategy
        let finalDocuments: any[] = []

        // Case 1: API count equals Default count - Compare and use API as source of truth
        if (apiDocuments.length === expectedDocuments.length) {
          finalDocuments = expectedDocuments.map((defaultDoc) => {
            const apiDoc = apiDocsMap.get(defaultDoc.label)
            return apiDoc || defaultDoc
          })
        }
        // Case 2: API count > Default count - Use API data
        else if (apiDocuments.length > expectedDocuments.length) {
          finalDocuments = apiDocuments
        }
        // Case 3: Default count > API count - Use Default data but update with available API data
        else {
          finalDocuments = expectedDocuments.map((defaultDoc) => {
            const apiDoc = apiDocsMap.get(defaultDoc.label)
            return apiDoc || defaultDoc
          })
        }

        // Create updated files object based on final documents
        const updatedFiles: Record<string, any[]> = {}

        finalDocuments.forEach((doc: any) => {
          // If it's an API document with files
          if (doc.document) {
            updatedFiles[doc.label] = doc.document.map((file: any) => ({
              name: file.name,
              id: file.id,
              type: file.name.split('.').pop(),
              status: file.status,
              isArchive: file.isArchive,
            }))
          }
          // If it's a default document or empty API document
          else {
            updatedFiles[doc.label] = []
          }
        })

        setDocumentsData(finalDocuments)
        setDocumentFiles(updatedFiles)

        // Notify parent components of status changes
        onDocumentsStatusChange(allDocumentsUploaded)
        if (onDocumentValidationChange) {
          onDocumentValidationChange(hasInvalidDocuments)
        }
      }
    })

    return () => {
      fileStatusChannel.unbind_all()
      pusher.unsubscribe(`file-channel-${claimNumber}`)
      listFileChannel.unbind_all()
      pusher.unsubscribe(`list-file-channel-${claimNumber}`)
    }
  }, [claimDetails.claimDetails.claimNumber, documentFiles])

  const status = claimDetails?.claimDetails?.status

  // Add this function to check if interactions should be disabled
  const isInteractionDisabled = () => {
    const disabledStatuses = [
      'Request IGL',
      'IGL RELEASED',
      'Daily Monitoring',
      'Request FGL',
      'FGL RELEASED',
      // 'Final Document Complete',
      'FGL Review',
      // 'Pending on FGL',
    ]
    return disabledStatuses.includes(status)
  }

  const handleFileChange = async (label: string, event: React.ChangeEvent<HTMLInputElement>) => {
    console.log('handleFileChange   ', isInteractionDisabled())
    if (isInteractionDisabled()) return

    if (event.target.files) {
      const selectedFiles = Array.from(event.target.files)

      try {
        const currentDoc = documentsData.find((doc) => doc.label === label)
        const fileInput = event.target as HTMLInputElement
        const currentFileId = fileInput.dataset.replaceFileId
          ? parseInt(fileInput.dataset.replaceFileId)
          : currentDoc?.document?.[0]?.id

        // Immediately update UI to show IDLE status
        setDocumentFiles((prevState) => ({
          ...prevState,
          [label]: selectedFiles.map((file) => ({
            name: file.name,
            type: file.name.split('.').pop() || '',
            status: 'IDLE',
            id: currentFileId || 0,
          })),
        }))

        // Also update documentsData for immediate UI reflection
        setDocumentsData((prevData) =>
          prevData.map((doc) => {
            if (doc.label === label) {
              return {
                ...doc,
                document: selectedFiles.map((file) => ({
                  name: file.name,
                  id: currentFileId || 0,
                  status: 'IDLE',
                  isArchive: false,
                })),
              }
            }
            return doc
          })
        )

        // Find existing files for this label and delete them
        const existingDoc = documentsData.find((doc) => doc.label === label)
        const existingFile = existingDoc?.document?.[0]

        if (existingFile && existingFile.id) {
          // Get the document key
          const docKey = expectedDocuments.find((doc) => doc.label === label)?.key

          // if (docKey !== undefined) {
          //   // First, delete the existing file
          //   await handleDeleteFile(existingFile, docKey)
          // } else {
          //   // If we can't find the key, use the simpler deleteFile function
          //   await deleteFileReupload(existingFile.id)
          // }
          // await deleteFileReupload(existingFile.id)
        }

        // After deletion, upload the new files
        await uploadFiles(label, selectedFiles, currentFileId)

        // Clear the replaceFileId after upload
        if (fileInput.dataset.replaceFileId) {
          delete fileInput.dataset.replaceFileId
        }

        // Finally, refresh the document list
        // await fetchDocuments()

        setIsReupload(true)
      } catch (error) {
        console.error('Error handling file change:', error)
        toast.error('Failed to upload file. Please try again.', {
          position: 'bottom-right',
          autoClose: 3000,
        })
      }
      // setIsReupload(false)
    }
  }

  const uploadFiles = async (label: string, files: File[], existingFileId?: number) => {
    if (!files || files.length === 0) return

    const formData = new FormData()
    files.forEach((file) => formData.append('files', file))

    const claimNumber = claimDetails.claimDetails.claimNumber
    const typeDocument = label

    // Always use the existing file ID if available
    const documentId = existingFileId || 0

    // const apiUrl = `${process.env.REACT_APP_API_CLAIM_URL}/api/Claims/UploadFiles?id=${0}&claimNumber=${claimNumber}&typeDocument=${encodeURIComponent(typeDocument)}&user=${user.currentUser?.email}`;
    const apiUrl = `${
      process.env.REACT_APP_API_CLAIM_URL
    }/api/Claims/UploadFiles?claimNumber=${claimNumber}&typeDocument=${encodeURIComponent(
      typeDocument
    )}&user=${user.currentUser?.email || 'SYSTEM'}&bucket=Discharge&id=${documentId}`

    try {
      setUploadStatus((prevStatus) => ({...prevStatus, [label]: null}))

      const response = await axios.post(apiUrl, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${user.currentUser?.token}`,
        },
      })

      if (response.data.isSuccess) {
        // After successful upload, fetch updated document list
        await fetchDocuments()
        setUploadStatus((prevStatus) => ({...prevStatus, [label]: true}))
        toast.success('File uploaded successfully! test1', {
          position: 'bottom-right',
          autoClose: 3000,
        })
      } else {
        throw new Error(response.data.message || 'Upload failed')
      }
    } catch (error) {
      console.error('Error uploading files:', error)
      setUploadStatus((prevStatus) => ({...prevStatus, [label]: false}))
      throw error
    }
  }

  console.log('Token Documents: ', user.currentUser?.token)

  const handleDeleteFile = async (file: any, docKey: number) => {
    const claimNumber = claimDetails.claimDetails.claimNumber
    const apiUrl = `${process.env.REACT_APP_API_CLAIM_URL}/api/Claims/Provider/DeleteFile?id=${file.id}&claimNumber=${claimNumber}`
    const headers = {
      Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
    }

    try {
      setDeletingFiles((prev) => ({...prev, [file.id]: true}))

      const response = await axios.post(apiUrl, {}, {headers})

      if (response.data === 'DELETED FILE SUCCESS.' || response.data.isSuccess) {
        setDocumentFiles((prev) => {
          const newFiles = {...prev}
          const docLabel = expectedDocuments.find((doc) => doc.key === docKey)?.label
          if (docLabel) {
            newFiles[docLabel] = []
          }
          return newFiles
        })

        setDocumentsData((prevData) =>
          prevData.map((doc) => {
            if (doc.key === docKey) {
              return {
                ...doc,
                document: [],
              }
            }
            return doc
          })
        )

        toast.success('File deleted successfully!', {
          position: 'bottom-right',
          autoClose: 3000,
        })

        await fetchDocuments()
      } else {
        throw new Error('Delete operation failed')
      }
    } catch (error) {
      console.error('Error deleting file:', error)
      // Only show error toast if it's a real error
      if (error instanceof Error && error.message !== 'DELETED FILE SUCCESS.') {
        toast.error('Error deleting file', {
          position: 'bottom-right',
          autoClose: 3000,
        })
      }
    } finally {
      setDeletingFiles((prev) => {
        const newState = {...prev}
        delete newState[file.id]
        return newState
      })
    }
  }

  // Modify openOptionsModal to check status first and use the new modal state
  const openOptionsModal = (doc: {label: string; key: number}) => {
    if (isInteractionDisabled()) return

    // Find the current document
    const currentDoc = documentsData
      .find((d) => d.label === doc.label)
      ?.document?.find((d) => d.status === 'INVALID')

    // Don't open modal if document status is VALID
    if (currentDoc?.status === 'VALID') return

    setActiveOptionsModal(doc)
    setShowOptionsModal(true)
  }

  const closeOptionsModal = () => {
    setActiveOptionsModal(null)
    setShowOptionsModal(false)
  }

  const handleSendToChat = () => {
    if (activeOptionsModal) {
      setChatMessage(`${activeOptionsModal.label}: Discuss document details`)
      setIsChatOpen(true)
      closeOptionsModal()
    }
  }

  const handleReUpload = () => {
    console.log('handleReUpload')
    if (activeOptionsModal) {
      console.log('Active Options Modal: ', activeOptionsModal)
      const fileInput = document.getElementById(
        `upload-${activeOptionsModal.label}`
      ) as HTMLInputElement
      if (fileInput) {
        // Find the current document and its file ID
        const currentDoc = documentsData.find((doc) => doc.label === activeOptionsModal.label)
        const currentFileId = currentDoc?.document?.[0]?.id

        // Store the file ID for use during upload
        if (currentFileId) {
          fileInput.dataset.replaceFileId = currentFileId.toString()
        }

        fileInput.click()
        closeOptionsModal()
      }
    }
  }

  const handleFileReplace = (docLabel: string, fileToReplace: any) => {
    const fileInput = document.getElementById(`upload-${docLabel}`) as HTMLInputElement
    if (fileInput) {
      if (fileToReplace?.id) {
        fileInput.dataset.replaceFileId = fileToReplace.id.toString()
      }
      fileInput.click()
    }
  }

  const getDocumentStatusIcon = (document: any) => {
    if (!document || !document.name) {
      return <FaExclamationCircle className='document-icon warning' />
    }

    switch (document.status) {
      case 'VALID':
        return <FaCheckCircle className='document-icon success' />
      case 'REQUEST':
        return <FaExclamationTriangle className='document-icon request' />
      default:
        return <FaExclamationCircle className='document-icon warning' />
    }
  }

  const getDocumentStatusText = (document: any) => {
    if (!document || !document.name) {
      return 'Document not uploaded'
    }

    switch (document.status) {
      case 'VALID':
        return 'Approved'
      case 'INVALID':
        return 'Revision needed'
      default:
        return 'Uploaded'
    }
  }

  const deleteFileReupload = async (fileId: number) => {
    const claimNumber = claimDetails.claimDetails.claimNumber
    const apiUrl = `${process.env.REACT_APP_API_CLAIM_URL}/api/Claims/Provider/DeleteFile?id=${fileId}&claimNumber=${claimNumber}`

    try {
      const response = await axios.post(
        apiUrl,
        {},
        {
          headers: {
            Authorization: `Bearer ${auth?.token || user.currentUser?.token}`,
          },
        }
      )

      if (response) {
        toast.success('File deleted successfully!', {
          position: 'bottom-right',
          autoClose: 3000,
        })

        // // Fetch the latest documents after deletion
        // await fetchDocuments() // Call fetchDocuments to refresh the document list
      } else {
        toast.error('Failed to delete file. Please try again.', {
          position: 'bottom-right',
          autoClose: 3000,
        })
      }
    } catch (error) {
      console.error('Error deleting file:', error)
      toast.error('Failed to delete file. Please try again.', {
        position: 'bottom-right',
        autoClose: 3000,
      })
    }
  }

  const deleteFile = async (fileId: number) => {
    const claimNumber = claimDetails.claimDetails.claimNumber
    const apiUrl = `${process.env.REACT_APP_API_CLAIM_URL}/api/Claims/Provider/DeleteFile?id=${fileId}&claimNumber=${claimNumber}`

    try {
      const response = await axios.post(
        apiUrl,
        {},
        {
          headers: {
            Authorization: `Bearer ${auth?.token || user.currentUser?.token}`,
          },
        }
      )

      if (response) {
        toast.success('File deleted successfully!', {
          position: 'bottom-right',
          autoClose: 3000,
        })

        // Fetch the latest documents after deletion
        await fetchDocuments() // Call fetchDocuments to refresh the document list
      } else {
        toast.error('Failed to delete file. Please try again.', {
          position: 'bottom-right',
          autoClose: 3000,
        })
      }
    } catch (error) {
      console.error('Error deleting file:', error)
      toast.error('Failed to delete file. Please try again.', {
        position: 'bottom-right',
        autoClose: 3000,
      })
    }
  }

  console.log('claimDetails.claimDetails.status: ', claimDetails.claimDetails.status)
  console.log("TEST DOKUMENT",documentsData);
  

  return (
    <>
      <ToastContainer
        position='top-right'
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme='light'
        style={{zIndex: 9999}}
      />
      <div className='documents-container'>
        {(documentsData.length > 0 ? documentsData : expectedDocuments)
          .filter((doc) => doc.label !== 'Chat Document') // Hide Chat Document
          .map((doc, index) => {
            const documents = doc.document || []

            return (
              <div
                className={`document-item ${
                  activeOptionsModal?.label === doc.label ? 'active' : ''
                }`}
                key={doc.label}
              >
                <div
                  className='document-header'
                  style={{
                    cursor:
                      isInteractionDisabled() || documents.every((doc) => doc.status === 'VALID')
                        ? 'default'
                        : 'pointer',
                  }}
                >
                  <div className='document-header-content'>
                    {getDocumentStatusIcon(documents[0])}
                    <span className='document-text'>{doc.label}</span>
                    {documents.some((doc) => doc.status === 'REQUEST') && (
                      <span className='document-status request'>Revision needed</span>
                    )}

                    {/* {!isInteractionDisabled() &&
                    !(documents.length > 0 && documents.every((doc) => doc.status === 'VALID')) && (
                      <button
                        className='btn btn-light-primary ms-auto'
                        onClick={() => {
                          // For documents that need upload or have REQUEST status
                          if (
                            documents.length === 0 ||
                            documents.some((doc) => doc.status === 'REQUEST')
                          ) {
                            const fileInput = document.getElementById(
                              `upload-${doc.label}`
                            ) as HTMLInputElement
                            if (fileInput) {
                              fileInput.click()
                            }
                          } else {
                            openOptionsModal(doc)
                          }
                        }}
                      >
                        {documents.some((doc) => doc.status === 'INVALID') ? 'Reupload' : 'Upload'}
                      </button>
                    )} */}
                  </div>
                  {!isInteractionDisabled() &&
                    // !(documents.length > 0 && documents.every((doc) => doc.status === 'VALID')) && (
                    !(
                      documents.length > 0 &&
                      documents.every((doc) => doc.status === 'VALID' || doc.status === 'IDLE')
                    ) && (
                      <button
                        className='btn btn-light-primary ms-auto'
                        onClick={() => {
                          // For documents that need upload or have REQUEST status
                          if (
                            documents.length === 0 ||
                            documents.some(
                              (doc) => doc.status === 'REQUEST' || doc.status === 'Request Document'
                            )
                          ) {
                            const fileInput = document.getElementById(
                              `upload-${doc.label}`
                            ) as HTMLInputElement
                            if (fileInput) {
                              fileInput.click()
                            }
                          } else {
                            openOptionsModal(doc)
                          }
                        }}
                      >
                        {/* {documents.some((doc) => doc.status === 'INVALID') && 'Reupload'} */}
                        {documents.some((doc) => doc.status === 'INVALID') ? 'Reupload' : 'Upload'}
                      </button>
                    )}
                </div>

                <div className='document-files-list'>
                  {documents.map((document, docIndex) => (
                    <div className='document-file-item' key={document.id}>
                      {document.name.toLowerCase().endsWith('.pdf') ? (
                        <FaFileAlt className='file-icon pdf' />
                      ) : (
                        <FaPaperclip className='file-icon' />
                      )}
                      <span className='document-file-name'>{document.name}</span>
                      <span className={`status-badge ${document.status.toLowerCase()}`}>
                        {getDocumentStatusText(document)}
                      </span>
                      {claimDetails.claimDetails.status !== 'FGL RELEASED' ||
                        (isInteractionDisabled() && (
                          <FaTimes
                            className='delete-icon'
                            style={{
                              color: 'red',
                              cursor: 'pointer',
                              marginLeft: '10px',
                            }}
                            onClick={() => deleteFile(document.id)}
                          />
                        ))}
                    </div>
                  ))}

                  {/* Make the label clickable for empty documents */}
                  {documents.length === 0 && (
                    <div
                      className='upload-area'
                      onClick={() => document.getElementById(`upload-${doc.label}`)?.click()}
                      style={{
                        cursor: 'pointer',
                        padding: '8px',
                        border: '1px dashed #ccc',
                        borderRadius: '4px',
                        marginTop: '8px',
                      }}
                    >
                      {/* This area is clickable for uploading files */}
                      Click to upload a file
                    </div>
                  )}
                </div>

                <input
                  id={`upload-${doc.label}`}
                  type='file'
                  accept='.pdf,.jpg,.jpeg,.png'
                  style={{display: 'none'}}
                  onChange={(e) => handleFileChange(doc.label, e)}
                  disabled={isInteractionDisabled()}
                  aria-label={`Upload ${doc.label}`}
                />
              </div>
            )
          })}

        <style>
          {`
            .document-files-list {
              margin-top: 8px;
            }
            
            .document-file-item {
              display: flex;
              align-items: center;
              padding: 8px;
              border-radius: 4px;
              background-color: #f5f8fa;
              margin-bottom: 4px;
            }
            
            .document-file-item:last-child {
              margin-bottom: 0;
            }

            .document-icon {
              margin-right: 10px;
              font-size: 18px;
            }
            
            .document-icon.success {
              color: #50CD89;
            }
            
            .document-icon.warning {
              color: #FFC700;
            }
            
            .document-icon.request {
              color: #F1416C;
            }

            .document-status {
              margin-left: auto;
              font-size: 12px;
              padding: 4px 8px;
              border-radius: 4px;
            }

            .document-status.request {
              color: #F1416C;
              background-color: #FFF5F8;
            }

            .status-badge {
              margin-left: auto;
              padding: 4px 8px;
              border-radius: 4px;
              font-size: 12px;
            }

            .status-badge.valid {
              background-color: #E8FFF3;
              color: #50CD89;
            }

            .status-badge.request {
              background-color: #FFF5F8;
              color: #F1416C;
            }

            .status-badge.idle {
              background-color: #FFF8DD;
              color: #FFC700;
            }
          `}
        </style>

        <Modal
          show={showOptionsModal && !!activeOptionsModal && !isInteractionDisabled()}
          onHide={closeOptionsModal}
          centered
          size='lg'
          backdrop='static'
          className='document-options-modal'
        >
          <Modal.Header closeButton>
            <Modal.Title>{activeOptionsModal?.label}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='d-flex flex-column'>
              <button
                className='btn btn-light-primary mb-3 d-flex align-items-center'
                onClick={handleReUpload}
              >
                <FaCloudUploadAlt className='me-2' />
                Re-Upload
              </button>
              {activeOptionsModal &&
                documentsData.find((doc) => doc.label === activeOptionsModal.label)?.document?.[0]
                  ?.status !== 'VALID' && (
                  <button
                    className='btn btn-light-danger d-flex align-items-center'
                    onClick={() => {
                      if (activeOptionsModal) {
                        const currentDoc = documentsData.find(
                          (doc) => doc.label === activeOptionsModal.label
                        )
                        if (currentDoc?.document?.[0]) {
                          handleDeleteFile(currentDoc.document[0], activeOptionsModal.key)
                          closeOptionsModal()
                        }
                      }
                    }}
                  >
                    <FaTrash className='me-2' />
                    Delete
                  </button>
                )}
            </div>
          </Modal.Body>
        </Modal>

        <ChatModal
          isOpen={isChatOpen}
          onClose={() => setIsChatOpen(false)}
          message={chatMessage}
          claimDetails={claimDetails}
        />
      </div>
    </>
  )
}

export default DocumentsFGL
